const STORE_LINKS = {
  chrome: null,
  edge: null,
  firefox: null,
  safari: null,
};

const PACKAGE_AVAILABILITY = {
  chromeDevZip: false,
  edgeDevZip: false,
  firefoxSignedXpi: false,
  safariApp: false,
};

export function validateExtensionPackages() {
  return {
    chrome: { ready: false, reason: "Chrome Web Store listing is not configured yet; no public ZIP is exposed." },
    edge: { ready: false, reason: "Microsoft Edge Add-ons listing is not configured yet; no public ZIP is exposed." },
    firefox: { ready: false, reason: "No signed Firefox XPI is configured, so downloads stay hidden." },
    safari: { ready: false, reason: "No Safari containing app/App Store link is configured yet." },
  };
}

export function detectExtensionInstallEnvironment(userAgent = navigator.userAgent || "") {
  const ua = userAgent.toLowerCase();
  const isEdge = /edg\//i.test(userAgent) || /edgios|edga/i.test(userAgent);
  const isFirefox = /firefox|fxios|fennec/i.test(userAgent);
  const isChrome = !isEdge && !isFirefox && (/chrome|crios|chromium/i.test(userAgent));
  const isSafari = !isChrome && !isEdge && !isFirefox && /safari/i.test(userAgent);
  const platform = /iphone|ipad|ipod/.test(ua) ? "ios" : /android/.test(ua) ? "android" : /mac os|macintosh/.test(ua) ? "macos" : /windows/.test(ua) ? "windows" : /linux/.test(ua) ? "linux" : "unknown";
  const browser = isEdge ? "edge" : isFirefox ? "firefox" : isChrome ? "chrome" : isSafari ? "safari" : "unknown";
  const isMobile = platform === "ios" || platform === "android";
  const isStandalone = window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
  const inAppBrowser = /fbav|instagram|line\/|wv\)|linkedinapp|twitter/i.test(userAgent);
  return buildInstallResult({ browser, platform, isMobile, isStandalone, inAppBrowser });
}

export function buildInstallResult({ browser, platform, isMobile, isStandalone = false, inAppBrowser = false }) {
  const isDesktop = !isMobile;
  const support = browser !== "unknown" && !inAppBrowser && (isDesktop || browser === "safari" || browser === "firefox");
  const method = browser === "safari" ? "app-store" : browser === "firefox" ? (PACKAGE_AVAILABILITY.firefoxSignedXpi ? "signed-xpi" : "store") : browser === "chrome" || browser === "edge" ? "store" : "unsupported";
  const mobileMessage = "Browser extensions may not be supported on this mobile browser. Use the Marstick Weather App instead.";
  const messages = {
    chrome: isMobile ? mobileMessage : "Install through the Chrome Web Store when the Marstick listing is published.",
    edge: isMobile ? mobileMessage : "Install through Microsoft Edge Add-ons when the Marstick listing is published.",
    firefox: isMobile ? mobileMessage : "Use Mozilla Add-ons or a signed XPI only when a verified package is available.",
    safari: platform === "ios" ? "Install the Safari extension app first, then enable it in Safari settings." : "Safari extensions install through a containing app, normally from the App Store or TestFlight.",
    unknown: "We could not detect your browser. Please choose manually.",
  };
  return {
    browser,
    platform,
    isMobile,
    isDesktop,
    isStandalone,
    inAppBrowser,
    supportsExtensionInstall: support && !isStandalone,
    recommendedInstallMethod: support ? method : "unsupported",
    installUrl: STORE_LINKS[browser] || null,
    fallbackUrl: browser === "edge" ? STORE_LINKS.chrome : null,
    userMessage: messages[browser] || messages.unknown,
    showDownload: false,
    showEnterpriseOption: isDesktop && ["chrome", "edge", "firefox", "safari"].includes(browser),
  };
}

export const extensionAvailability = { STORE_LINKS, PACKAGE_AVAILABILITY };